<template>
  <div class="data-card">
    <el-card>
      <div slot="header">
        <span class="title">{{ cardData.title }}</span>
        <el-tooltip effect="dark" :content="tips" placement="bottom-end">
          <i class="el-icon-warning-outline" style="float: right;"></i>
        </el-tooltip>
      </div>
      <div class="content">
        <div class="amount">
          {{ cardData.amount }} <span class="unit">{{ cardData.unit }}</span>
        </div>
        <div class="from">
          <div class="name">周环比</div>
          <img v-if="cardData.weeksFrom >= 0" class="icon" src="../../../assets/images/report/up.png" alt="up" />
          <img v-else class="icon" src="../../../assets/images/report/down.png" alt="up" />
          <div class="ratio">{{ cardData.weeksFrom + "%" }}</div>
          <div class="name">日环比</div>
          <img v-if="cardData.daysFrom >= 0" class="icon" src="../../../assets/images/report/up.png" alt="up" />
          <img v-else class="icon" src="../../../assets/images/report/down.png" alt="up" />
          <div class="ratio">{{ cardData.daysFrom + "%" }}</div>
        </div>
        <div class="daily">
          {{ description + " " + cardData.dailyTurnover + " " + cardData.unit }}
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  props: {
    cardData: {
      type: Object,
      default: () => {
        return {
          title: "",
          unit: "",
          amount: 0,
          weeksFrom: 0,
          daysFrom: 0,
          dailyTurnover: 0
        };
      }
    },
    firstTradeTime: {
      type: String,
      default: ""
    }
  },

  computed: {
    description() {
      if (this.cardData.title === "总交易额") {
        return "日交易额";
      } else if (this.cardData.title === "总交易笔数") {
        return "日交易笔数";
      } else if (this.cardData.title === "客单价") {
        return "今日客单价";
      }

      return "";
    },

    tips() {
      if (this.firstTradeTime) {
        return this.cardData.title + "：自" + this.firstTradeTime + "至今的" + this.cardData.title + "。";
      }
      return "截止当前时间点的" + this.cardData.title + "。";
    }
  }
};
</script>

<style lang="scss" scoped>
.data-card {
  max-width: 450px;
  margin: auto;

  .title {
    font-size: 14px;
    color: #999;
  }

  .content {
    .amount {
      font-size: 28px;
      color: #333;
      margin-bottom: 20px;

      .unit {
        font-size: 13px;
      }
    }

    .from {
      display: flex;
      align-items: center;
      font-size: 13px;
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid #ebeef5;

      .name {
        margin-right: 5px;
      }

      .icon {
        margin-right: 5px;
        width: 15px;
        height: 15px;
      }

      .ratio {
        margin-right: 30px;
      }
    }

    .daily {
      font-size: 13px;
      color: #333;
    }
  }
}
</style>
